"use strict";
module.exports = {
    entityModel: 'categoryTree',
    events: {
        CATEGORY_TREE_UPDATED: 'CATEGORY_TREE_UPDATED',
        CATEGORY_TREE_CREATED: 'CATEGORY_TREE_CREATED',
    },
    actions: {
        get: 'v1.categoryTree.get',
        list: 'v1.categoryTree.list',
        writeCategoryTree: 'v1.categoryTree.writeCategoryTree',
        upsert: 'v1.categoryTree.upsert',
        upsertWhenEmpty: 'v1.categoryTree.upsertWhenEmpty',
        updateWhenEmpty: 'v1.categoryTree.updateWhenEmpty',
        update: 'v1.categoryTree.update',
    },
    categories: {},
};
